import { app } from '../../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.directory-groups.directory.bulk-verification-result', {
        url: '/bulk-verification-result',
        params: {importedUsers: null},
        views: {
            '@company.user-directories.directory-groups': 'companyUserDirectoriesDirectoryGroupsDirectoryBulkVerificationResult'
        },
        resolve: {importedUsers},
    });
}

/** @ngInject */
function importedUsers($stateParams) {
    return $stateParams.importedUsers;
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/directory-groups/directory/bulk-verification-result/bulk-verification-result.state.js